export class PagedApiResponse<T> {
    list: Array<T>;
    totalNumberOfRecords: number;
    rows: Array<T>;
    count: number;
}
